export enum GridConnectionRef {
  hta = "hta",
  htb = "htb",
  bt = "bt",
}

// Impact Study Default Values based on project configuration
export enum ImpactStudyDefaultValue {
  // PV + (Ombrières OR Toiture) + Bâtiments
  BUILDING_TYPE = 63000,
  // PV + (NOT Ombrières AND NOT Toiture) + Cas 2 bis
  CAS_2_BIS_TYPE = 238000,
  // PV + (NOT Ombrières AND NOT Toiture) + (NOT Cas 2 bis)
  OTHER_TYPE = 163000,
}
